import { $, handleESC } from '../utils/Utils';

const megaNav = (() => {
  const config = {
    get triggers() {
      return this.triggerCN
        .map(CN => [...document.querySelectorAll(`.${CN}`)])
        .reduce((acc, current) => [...acc, ...current]);
    },
    get radios() {
      return this.radioCN
        .map(CN => [...document.querySelectorAll(`.${CN}`)])
        .reduce((acc, current) => [...acc, ...current]);
    },
    triggerCN: ['nav__mega'],
    radioCN: ['nav__mega__trigger'],
    megaContainerCN: ['nav__mega__container'],
    bodyCN: 'meganav-open',
  };

  let currentPageElement;

  const removeCurrentItem = () => {
    // eslint-disable-next-line no-restricted-syntax
    for (const item of document.querySelectorAll(
      '.nav__desktop ul.nav li.nav__item',
    )) {
      item.classList.remove('current-menu-item');
    }
  };

  const restoreInitialCurrentItem = () => {
    if (currentPageElement) {
      currentPageElement.classList.add('current-menu-item');
    }
  };

  const hideNav = () => {
    removeCurrentItem();
    restoreInitialCurrentItem();

    config.radios.forEach(radio => {
      radio.checked = false; // eslint-disable-line no-param-reassign
    });

    document.body.classList.remove(config.bodyCN);
    handleESC.stop();
  };

  const showNav = e => {
    removeCurrentItem();

    if (e && e.target && e.target.labels.length > 0) {
      const label = e.target.labels[0];
      label.parentNode.classList.add('current-menu-item');
    }

    document.body.classList.add(config.bodyCN);
    handleESC.init(() => hideNav());
  };

  const handleClick = ({ e }) => {
    if (
      document.body.classList.contains(config.bodyCN) &&
      !$(`.${config.megaContainerCN}`)[0].contains(e.target) && !document.getElementById('mega-nav-5').checked
    ) {
      hideNav();
    }
  };

  const handleChange = e => {
    let checked = false;
    config.radios.forEach(radio => {
      if (radio.checked) checked = true;
    });

    if (checked) {
      showNav(e);
    } else {
      hideNav();
    }
  };

  const handleLoginBoxClose = () => {
    document.getElementById('mega-nav-5').checked = false;
  };


  const init = () => {
    currentPageElement = document.querySelector(
      '.nav__desktop ul.nav li.current-menu-item',
    );

    if (config.triggers.length > 0) {
      // Close mobile nav if click on outside area
      document.addEventListener('click', e => handleClick({ e }));

      // close login if click close icon
      document.querySelector('.login-close').addEventListener('click', () => handleLoginBoxClose())

      // Add body class if nav is opens
      config.radios.forEach(radio => {
        radio.addEventListener('change', e => handleChange(e));

        let event;
        if (typeof Event === 'function') {
          event = new Event('change');
        } else {
          event = document.createEvent('Event');
          event.initEvent('change', true, true);
        }

        radio.dispatchEvent(event);
      });
    }
  };

  return {
    init,
  };
})();

export const queueMega = () =>
  setTimeout(() => {
    megaNav.init();
  }, 1000);

megaNav.init();
